import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexModal',
  setup(__props) {

const BasicModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/BasicModal.vue"))
const SizeModel = defineAsyncComponent(() => import("@/components/theme/uikits/modal/SizeModel.vue"))
const FullscreenModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/FullscreenModal.vue"))
const CenteredModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/CenteredModal.vue"))
const ToggleModals = defineAsyncComponent(() => import("@/components/theme/uikits/modal/ToggleModals.vue"))
const StaticModal = defineAsyncComponent(() => import("@/components/theme/uikits/modal/StaticModal.vue"))
const CustomModals = defineAsyncComponent(() => import("@/components/theme/uikits/modal/CustomModals.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BasicModal)),
      _createVNode(_unref(SizeModel)),
      _createVNode(_unref(FullscreenModal)),
      _createVNode(_unref(CenteredModal)),
      _createVNode(_unref(ToggleModals)),
      _createVNode(_unref(StaticModal)),
      _createVNode(_unref(CustomModals))
    ])
  ]))
}
}

})